import React from 'react';

import '../../../scss/main.scss';

export default function Styles(): React.ReactNode {
    return <></>;
}
